import { render, staticRenderFns } from "./storeContents.vue?vue&type=template&id=4c7bcd6f"
import script from "./storeContents.vue?vue&type=script&lang=js"
export * from "./storeContents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports